import {
  CUSTOMER_LIST_GET,
  CUSTOMER_DETAIL_GET,
  BILL_NUMBER_GENERATE_POST,
} from "src/fetch/url";
import { curl } from 'zh-common-modules';

export const getCustomerReportList = (params, cb) => {
  return () => {
    curl
      .get(CUSTOMER_LIST_GET, params)
      .then((content) => {
        cb?.(content);
      });
  };
};

export const getCustomerDetail = (params, cb) => {
  return () => {
    curl
      .get(CUSTOMER_DETAIL_GET, params)
      .then((content) => {
        cb?.(content);
      });
  };
};

export const generateBill = (params, cb) => {
  return () => {
    curl
      .post(BILL_NUMBER_GENERATE_POST, params)
      .then((content) => {
        cb?.(content);
      });
  };
};
